import axios from "axios";

//IMPORT API ROUTE URL
import { GET_ALL_RAW_SKILLS_ROUTE } from "./apiRoutes";

const fetchAllRawSkills = (resource_slug, user_slug) => {
  var postData = new FormData();

  postData.append("user_slug", user_slug);
  postData.append("resource_slug", resource_slug);

  return axios
    .post(GET_ALL_RAW_SKILLS_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default fetchAllRawSkills;
